// extracted by mini-css-extract-plugin
module.exports = {"container":"cards_container__2nAh3","confirmed":"cards_confirmed__3lNnW","recovered":"cards_recovered__26Qnc","deaths":"cards_deaths__lYVzI"};